// extracted by mini-css-extract-plugin
export default {"buttonMore":"ItemComponent_buttonMore__Z-HZm","item":"ItemComponent_item__sgLQW"};